import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 5243C745-48FC-4DE9-83F8-138464C7D0D8
 * name cabin-a-frame
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cabin-a-frame.svg
 * tags
 * - Home Automation 
 */
export const CabinAFrameIcon = createSvgIcon(<><path d="M12 3L4 21H20L12 3M9 19H7.08L9 14.67V19M13 19H11V14H13V19M10.19 12L12 7.92L13.81 12H10.19M15 14.67L16.92 19H15V14.67Z" /></>, 'CabinAFrameIcon');
export default CabinAFrameIcon